import { useState } from 'react';
import { AddUserAccountDto } from '../../../../../../types';
import {
  isValidEmail,
  isValidationValidated,
} from '../../../../../../utils/helper';
import SelectUserRoleDropdown from '../../../../../global-components/selectUserRoleDropdown';
import { Link } from 'react-router-dom';

interface Props {
  formData: AddUserAccountDto;
  setFormData: any;
  setShowUserDetailForm: any;
  setShowUserSettingForm: any;
  formValidations: any;
  setFormValidations: any;
}
function UserDetailContainer({
  formData,
  setFormData,
  setShowUserDetailForm,
  setShowUserSettingForm,
  formValidations,
  setFormValidations,
}: Props) {
  const [validating, setValidating] = useState(false);
  function handleNext() {
    setValidating(true);
    if (isValidationValidated(formValidations)) {
      setShowUserDetailForm(false);
      setShowUserSettingForm(true);
    }
  }
  return (
    <div
      className='row mt-4 '
      id='user_details'
      style={{ width: '100%' }}
    >
      <div className='col-sm-12 col-md-3'></div>
      <div className='col-sm-12 col-md-12'>
        <div className='ubbe-card pb-5'>
          <div className='ubbe-card-header'>
            <h5 className='ps-3 mb-0 GlobalBoxHead'>User Details</h5>
          </div>
          <div className='card-body pt-2 px-4 pb-5'>
            <div className='col-md-4'>
              {' '}
              <div className={'mb-3'}>
                <label
                  htmlFor='user_role'
                  className=' globalInputLabel'
                >
                  User Role <span className='text-danger'>*</span>
                </label>
                <SelectUserRoleDropdown
                  selectedUserRole={formData?.role}
                  setSelectedUserRole={(val: any) => {
                    setFormData({
                      ...formData,
                      role: val,
                    });
                  }}
                />
              </div>
            </div>
            <div className='col-md-8'></div>
            <div className='row'>
              <div className='col-md-4'>
                {' '}
                <div className='mb-3'>
                  <label
                    htmlFor='first_name'
                    className='globalInputLabel'
                  >
                    First Name <span className='text-danger'>*</span>
                  </label>
                  <input
                    type='text'
                    className={`form-control  ubbe-input ${
                      formData.first_name ? 'highlighted-border' : ''
                    }`}
                    id='first_name'
                    placeholder='First Name'
                    autoComplete='new-password'
                    maxLength={30}
                    value={formData.first_name}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        first_name: e.target.value,
                      });
                      setFormValidations({
                        ...formValidations,
                        first_name: e.target.value !== '',
                      });
                    }}
                  />
                  {validating && formData.first_name === '' && (
                    <div className='error_text'>
                      {'Please provide a valid first name.'}
                    </div>
                  )}
                </div>
              </div>
              <div className='col-md-4'>
                {' '}
                <div className='mb-3'>
                  <label
                    htmlFor='last_name'
                    className='globalInputLabel'
                  >
                    Last Name <span className='text-danger'>*</span>
                  </label>
                  <input
                    type='text'
                    className={`form-control  ubbe-input ${
                      formData.last_name ? 'highlighted-border' : ''
                    }`}
                    id='last_name'
                    placeholder='Last Name'
                    autoComplete='new-password'
                    maxLength={30}
                    value={formData.last_name}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        last_name: e.target.value,
                      });
                      setFormValidations({
                        ...formValidations,
                        last_name: e.target.value !== '',
                      });
                    }}
                  />
                  {validating && formData.last_name === '' && (
                    <div className='error_text'>
                      {'Please provide a valid last name.'}
                    </div>
                  )}
                </div>
              </div>
              <div className='col-md-4'> </div>{' '}
            </div>
            <div className='row'>
              <div className='col-md-4'>
                {' '}
                <div className='mb-3'>
                  <label
                    htmlFor='phone'
                    className='globalInputLabel'
                  >
                    Phone Number<span className='text-danger'>*</span>
                  </label>
                  <input
                    type='text'
                    className={`form-control  ubbe-input ${
                      formData.phone ? 'highlighted-border' : ''
                    }`}
                    id='phone'
                    placeholder='Phone number: 1112223333'
                    autoComplete='new-password'
                    minLength={10}
                    maxLength={15}
                    value={formData.phone}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        phone: e.target.value.replace(/[^0-9]/g, ''),
                      });
                      setFormValidations({
                        ...formValidations,
                        phone: e.target.value.length > 9,
                      });
                    }}
                  />
                  {validating && formData.phone.length < 10 && (
                    <div className='error_text'>
                      {'Please provide a valid phone.'}
                    </div>
                  )}
                </div>
              </div>
              <div className='col-md-4'>
                {' '}
                <div className='mb-3'>
                  <label
                    htmlFor='email'
                    className='globalInputLabel'
                  >
                    Email Address<span className='text-danger'>*</span>
                  </label>
                  <input
                    type='email'
                    className={`form-control  ubbe-input ${
                      formData.email ? 'highlighted-border' : ''
                    }`}
                    id='email'
                    placeholder='Email Address'
                    autoComplete='new-password'
                    maxLength={100}
                    value={formData.email}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        email: e.target.value,
                        username: e.target.value,
                      });
                      setFormValidations({
                        ...formValidations,
                        email: isValidEmail(e.target.value),
                      });
                    }}
                  />
                  {validating && !isValidEmail(formData.email) && (
                    <div className='error_text'>
                      {'Please provide a valid email.'}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='d-flex mt-4 justify-content-between align-items-center'>
        <div className=''>
          <div
            className='btn btn-ubbe-new-back d-flex gap-2'
            onClick={() => {
              window.history.back(); // Go back one page
              setShowUserDetailForm(false);
            }}
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='15'
              height='8'
              viewBox='0 0 15 8'
              fill='none'
            >
              <path
                d='M3.03077 0.670207L0.176923 3.5735C0.123077 3.62828 0.0769229 3.69871 0.0461536 3.77697C0.0461536 3.7848 0.0461536 3.79262 0.0384613 3.80045C0.0153844 3.86305 -1.56239e-07 3.92566 -1.53161e-07 3.99609C-1.4632e-07 4.1526 0.0615383 4.30129 0.169231 4.41084L3.03077 7.32979C3.25385 7.55674 3.62308 7.55674 3.84615 7.32979C4.06923 7.10285 4.06923 6.72722 3.84615 6.50028L1.96154 4.58301L14.4231 4.58301C14.7385 4.58301 15 4.31694 15 3.99609C15 3.67524 14.7385 3.40917 14.4231 3.40917L1.96923 3.40917L3.84615 1.49972C3.96154 1.38234 4.01538 1.23365 4.01538 1.08496C4.01538 0.936277 3.96154 0.787591 3.84615 0.670207C3.62308 0.443265 3.26154 0.443265 3.03077 0.670207Z'
                fill='black'
              />
            </svg>
            Back
          </div>
        </div>
        <div className=''>
          <p
            className='btn btn-ubbe-new-blue mb-0'
            onClick={() => {
              handleNext();
            }}
          >
            Continue
          </p>
        </div>
      </div>
    </div>
  );
}

export default UserDetailContainer;
